export const getCurrencySign = (currencyCode: string) => {
    let retCurrSign = '';
    const currencyCodeLowerCase = currencyCode.toLowerCase();
    switch (currencyCodeLowerCase) {
        case 'gbp':
            retCurrSign = '£';
            break;
        case 'eur':
            retCurrSign = '€';
            break;
        case 'usd':
        case 'cad':
        case 'usn':
            retCurrSign = '$';
            break;
        case 'czk':
            retCurrSign = 'Kč';
            break;
        case 'hrk':
            retCurrSign = 'kn';
            break;
        case 'huf':
            retCurrSign = 'Ft';
            break;
        case 'ron':
            retCurrSign = 'lei';
            break;
        case 'jpy':
            retCurrSign = '¥';
            break;
        case 'chf':
            retCurrSign = 'Fr';
            break;
        case 'pln':
            retCurrSign = 'zł';
            break;
        default:
            retCurrSign = currencyCode;
    }

    return retCurrSign;
};

const colorKeysInOrder = [
    'Categorical/1/bg',
    'Categorical/2/bg',
    'Categorical/3/bg',
    'Categorical/4/bg',
    'Categorical/5/bg',
    'Categorical/6/bg',
    'Categorical/7/bg',
    'Categorical/8/bg',
    'Categorical/9/bg',
];
const colorEmphasisKeysInOrder = [
    'Categorical/1/emphasis',
    'Categorical/2/emphasis',
    'Categorical/3/emphasis',
    'Categorical/4/emphasis',
    'Categorical/5/emphasis',
    'Categorical/6/emphasis',
    'Categorical/7/emphasis',
    'Categorical/8/emphasis',
    'Categorical/9/emphasis',
];
export const getDarkColorInOrder = (theme: any, index: number) => {
    const key = colorEmphasisKeysInOrder[index % colorEmphasisKeysInOrder.length];
    return theme[key];
};
export const getLightColorInOrder = (theme: any, index: number) => {
    const key = colorKeysInOrder[index % colorKeysInOrder.length];
    return theme[key];
};

/** Currencies as the report filters list them: alphabetical, A to Z (MP-15909). */
export const sortReportCurrencies = (currencies?: string[] | null): string[] =>
    [...(currencies ?? [])].sort((a, b) => a.localeCompare(b));

/**
 * Currency the report pages preselect: the client's default currency when one is set and still
 * enabled, otherwise the first currency of the A to Z list.
 */
export const getReportDefaultCurrency = (config?: {
    defaultCurrency?: string | null;
    enabledCurrencies?: string[];
}): string | undefined => {
    const enabledCurrencies = sortReportCurrencies(config?.enabledCurrencies);
    const defaultCurrency = config?.defaultCurrency;
    return defaultCurrency && enabledCurrencies.includes(defaultCurrency)
        ? defaultCurrency
        : enabledCurrencies[0];
};
